import React, { FC, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { FormBasicsDto, FormState } from "@green0meter/api-client";

import { MultistepForm } from "@components/common";
import { useGetFormsConfigs } from "@api";
import { CircularProgress } from "@components/base";
import { useUserStore } from "@store/user";

const FormBuilderDetailPage: FC = () => {
  const { formId } = useParams();
  const { user } = useUserStore();
  const [formBasics, setFormBasics] = useState<FormBasicsDto>();

  const { formsConfigs, formsConfigEnabled, isFetchingFormsConfigs } =
    useGetFormsConfigs(user);

  useEffect(() => {
    const formConfig = formsConfigs?.items.find((form) => form.id === formId);

    if (formConfig) {
      setFormBasics({
        ...formConfig,
        isTemplate: true,
        validFrom: "",
        validTo: "",
        isLocked: false,
        isCalculationReady: false,
        state: FormState.InProgress,
      });
    }
  }, [formId, formsConfigs]);

  return (
    formsConfigEnabled &&
    (formId && isFetchingFormsConfigs ? (
      <CircularProgress />
    ) : formBasics ? (
      <MultistepForm
        formSettings={{
          formBasics,
          returnUrl: "/form-builder",
          button: {
            label: "Save",
            onClick: () => {},
          },
          editMode: true,
        }}
        isSubmissionPending={false}
      />
    ) : null)
  );
};

export default FormBuilderDetailPage;
